module.exports = __webpack_public_path__ + "img/fire-poster.96325d27.jpg";